/* eslint-disable react/prop-types */
import React from "react";
import { CheckCircle2 } from "lucide-react";

interface NewsletterContntAuditProps {
  response: any;
}

const NewsletterContextAudit: React.FC<NewsletterContntAuditProps> = ({ response }) => {
  if (!response || !response.content_audit) {
    return <div className="p-4 text-sm text-gray-600">No content audit data available.</div>;
  }

  const { content_audit } = response;
  const { columns, rows } = content_audit;

  // remove any "OK" column entries (case-insensitive)
  if (Array.isArray(columns)) {
    for (let i = columns.length - 1; i >= 0; i--) {
      const v = columns[i];
      if (typeof v === "string" && v.trim().toUpperCase() === "OK") {
        columns.splice(i, 1);
      }
    }
  }

  return (
    <div className="h-[90vh] max-w-xl border rounded-xl border-gray-300 overflow-y-auto pn_scroller p-3">
      <h2 className="text-lg font-bold text-gray-900 mb-4">Audit & Compliance View</h2>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              {columns.map((column: string, idx: number) => (
                <th key={idx} className="text-left py-4 px-4 text-gray-600 font-medium text-base">
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row: any, idx: number) => (
              <tr key={idx} className="border-b border-gray-100 last:border-b-0">
                <td className="py-2 px-4 text-gray-700 font-normal">{row.section}</td>
                <td className="py-2 px-4 text-gray-600">{row.check_type}</td>
                <td className="py-2 px-4">
                  <div className="flex items-center gap-2">
                    {row.ok == "1" && (
                      <CheckCircle2 className="w-2 h-2 text-green-500 flex-shrink-0" />
                    )}
                    <span className="text-gray-700">{row.status}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NewsletterContextAudit;
